import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Styles from './Review.css'

class ResetConfirmModal extends Component {

  render () {
    return (
      <div>
        <Modal
          style={{top: '120px'}}
          show={this.props.show}
          onHide={this._close}
          container={this}
          backdrop='static'
          dialogClassName={Styles['modal-dialog']}
        >
          <Modal.Header className={Styles['modal-header-danger']} closeButton>
            <Modal.Title style={{ fontSize: '19px', fontWeight: '300' }}><div>Reset Loyalty Program</div></Modal.Title>
          </Modal.Header>
          <Modal.Body className={`${Styles['modal-body']} top10 bottom10`}>
            Are you sure you want to reset the loyalty program? You will discard the current loyalty<br />
            setting, reset the program and the customer's point balance.<br /><br />

            <span className={Styles['modal-highlighted-message']}>
              Please make sure all customers & outlets are aware of this reset.
            </span>
          </Modal.Body>
          <Modal.Footer>
            <Button style={{width: '100px'}} className='btn btn-default' onClick={this._close}>Cancel</Button>
            <Button style={{width: '100px'}} className='btn btn-danger' onClick={this._onClickReset}>OK</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  _close = (e) => {
    e.stopPropagation()
    this.props.close()
  }

  _onClickReset = (e) => {
    e.stopPropagation()
    this.props.confirmReset()
  }
}

export default ResetConfirmModal



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Review/ResetConfirmModal.js